import { render } from "./BaseTitle.vue?vue&type=template&id=56067672"
import script from "./BaseTitle.vue?vue&type=script&lang=js"
export * from "./BaseTitle.vue?vue&type=script&lang=js"
script.render = render

export default script